module.exports = __webpack_public_path__ + "img/banner_9.6061829b.png";